// extracted by mini-css-extract-plugin
export default {"container":"SetupDetails_container__5Sz8m"};